import { render, staticRenderFns } from "./ProdFamilySlider.vue?vue&type=template&id=2c981b4f&"
import script from "./ProdFamilySlider.vue?vue&type=script&lang=js&"
export * from "./ProdFamilySlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports